module.exports = __webpack_public_path__ + "img/question-mark-avatar.5acba150.svg";